declare global {
  var KYC: EnvVariablesProps;
}

type EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL: string;
  // Support hand-off targets. Neither is a credential: a public help-desk URL
  // and a public phone number, so no-secrets-in-bundle is satisfied by what
  // they are, not by where they are read.
  REACT_APP_SUPPORT_ZOHO_URL: string;
  REACT_APP_SUPPORT_WHATSAPP: string;
};

const getConfigValue = (key: keyof EnvVariablesProps, defaultValue: string) => {
  if (global.KYC && global.KYC[key] !== defaultValue) {
    return global.KYC[key];
  }

  if (process.env.NODE_ENV !== "production" && process.env[key]) {
    return String(process.env[key]);
  }

  console.log(`The key ${key} in index.html should be replaced!`);
  return global.KYC && global.KYC[key];
};

const config: EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL: getConfigValue(
    "REACT_APP_PROXY_BASE_URL",
    "VARPROXYBASEURL"
  ),
  REACT_APP_SUPPORT_ZOHO_URL: getConfigValue(
    "REACT_APP_SUPPORT_ZOHO_URL",
    "VARSUPPORTZOHOURL"
  ),
  REACT_APP_SUPPORT_WHATSAPP: getConfigValue(
    "REACT_APP_SUPPORT_WHATSAPP",
    "VARSUPPORTWHATSAPP"
  ),
};

export default config;
